import { render, staticRenderFns } from "./SucaiCount.vue?vue&type=template&id=38535126"
import script from "./SucaiCount.vue?vue&type=script&lang=js"
export * from "./SucaiCount.vue?vue&type=script&lang=js"
import style0 from "./SucaiCount.vue?vue&type=style&index=0&id=38535126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports